import { React, FC} from 'external/react'
import {styled} from 'external/material'

import UnitDuration from './UnitDuration'
import Lessons from './Lessons'
import Resources from './Resources'
import SelectGroup from './SelectGroup'

const StyledSideBar = styled('div')(sideBarStyles as any)

type SidebarProps = {
  className?: string
}
const Sidebar: FC<SidebarProps> = props => {
  const {className} = props
    return (
      <StyledSideBar className={className}>
        <SelectGroup />
        <UnitDuration />
        <Lessons />
        <Resources />
      </StyledSideBar>
    )
}

function sideBarStyles() {
  return {

     display: 'flex',
     flexDirection: 'column',
     flexGrow: 1,

     gap: '26px',
     alignItems: 'center',

     boxSizing: 'border-box',

     padding: '20px',
     marginLeft: '20px',

     backgroundColor: '#fff',

     "& .date-picker": {
       width: '100%',
     },

     '& .side-bar-section': {
        paddingBottom: '20px',
        borderBottom: 'solid 1px #d8d8d8'
     }
  }
}


export { Sidebar as default }